import { Box, Skeleton } from "@mui/material"

export default function CustomerKPISkeleton() {
    return (
        <Box sx={{ mt: 1, gap: 2, display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr 1fr", }, }}>
            {Array.from({ length: 4 }).map((_, index) => (
                <Box
                    key={index}
                    sx={{
                        p: 2,
                        borderRadius: 2,
                        display: "flex",
                        flexDirection: "column",
                        backgroundColor: (theme) => theme.palette.mode === "light" ? "#f5f5f5" : "#263744",
                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                        <Skeleton width={180} height={24} />
                        <Skeleton width={70} height={28} sx={{ borderRadius: 1 }} />
                    </Box>

                    <Skeleton width={200} height={35} />

                    <Box sx={{ display: "flex", gap: 2, width: "100%", mt: 2, flexDirection: "column" }}>
                        <Box sx={{ display: "flex", justifyContent: "space-between", }}>
                            <Skeleton width={120} height={18} />
                            <Skeleton width={160} height={18} />
                        </Box>

                        <Skeleton
                            variant="rectangular"
                            width="100%"
                            height={16}
                            sx={{ borderRadius: 4 }}
                        />
                    </Box>
                </Box>
            ))}
        </Box >
    )
}